import { render, staticRenderFns } from "./CampaignQuestionnaires.vue?vue&type=template&id=24965da4"
import script from "./CampaignQuestionnaires.vue?vue&type=script&lang=js"
export * from "./CampaignQuestionnaires.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24965da4')) {
      api.createRecord('24965da4', component.options)
    } else {
      api.reload('24965da4', component.options)
    }
    module.hot.accept("./CampaignQuestionnaires.vue?vue&type=template&id=24965da4", function () {
      api.rerender('24965da4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/referentiel/parameters/CampaignQuestionnaires.vue"
export default component.exports